<template>
  <div v-if="loadComplete" :style="{ 'background-color': waiverConfigurations.background_color, 'overflow': 'auto',
  'position' : 'absolute',
  'top' : '0px',
    'right' : '0px',
  'bottom':'0px',
  'left':'0px'}">
    <link v-if="!loading" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + waiverConfigurations.font_family">
    <link v-if="!loading" rel="stylesheet" :href="'https://fonts.googleapis.com/css?family=' + waiverConfigurations.font_family_card">

    <!--    Loader-->
    <loading-panel :loading="loading"></loading-panel>
    <not-found-page v-show="notFound"></not-found-page>
    <div v-show="!notFound" class="row mt-2 mr-2 justify-content-end text-right">
      <div class="col-auto">
        <language-switcher v-if="waiverConfigurations && Number(waiverConfigurations.show_language_switcher) === 1" :color="waiverConfigurations.text_color"/>
      </div>
    </div>

    <div class="container" v-show="!notFound">
      <div class="row">
        <div class="col-md-6 mt-5 mb-4 ml-auto mr-auto text-center">
          <img :height="waiverConfigurations.logo_height" :width="waiverConfigurations.logo_width" :style="{'object-fit': waiverConfigurations.logo_fit}" :src="waiverConfigurations.logo" alt="logo">
          <h4 :style="{'font-family': waiverConfigurations.font_family, 'color': waiverConfigurations.text_color}" class="mt-3 description">
            {{waiverConfigurations.main_message}}
          </h4>
        </div>
      </div>

<!--      Lookup module-->
      <div v-show="bookings.length <= 0">
        <div class="row justify-content-center text-center" v-if="!is_kiosk">
          <div class="col">
            <div class="row mb-1 justify-content-center"
                 :style="{'font-family': waiverConfigurations.font_family}">
              <a :style="{'color': waiverConfigurations.text_color, 'font-size': 'medium' }"
                 :disabled="showPrevious(current)" v-on:click="decrementDay(current)"
                 class="btn btn-link btn-primary d-none d-sm-block">
                <i class="tim-icons icon-minimal-left"></i> &nbsp;  {{ $t('checkin.previous') }}
              </a>
              <base-input :secondary-color="waiverConfigurations.text_color_card"
                          class="mt-2" inputmode='none'>
                <el-date-picker :editable="false"
                                :clearable="false"
                                class="date-field-themed"
                                :style="{'--date-field-color': waiverConfigurations.text_color}"
                                prefix-icon="' '"
                                type="date"
                                :placeholder="$t('checkin.selectDate')"
                                value-format="yyyy-MM-dd"
                                :format="day_of_week + ' ' + locale.date_format"
                                v-model="current"
                                :picker-options="pickerOptions"
                >
                </el-date-picker>
              </base-input>
              <a :style="{'color': waiverConfigurations.text_color, 'font-size': 'medium' }"
                 v-on:click="incrementDay(current)"
                 class="btn btn-link btn-primary d-none d-sm-block">
                {{ $t('checkin.next') }} &nbsp;<i class="tim-icons icon-minimal-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="row mt-3 justify-content-center text-center" v-if="waiverConfigurations.display_section_titles">
          <div class="col" :style="{'font-family': waiverConfigurations.font_family}">
            <h3>
              <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
                {{ sections[0].name }}
              </span>
            </h3>
          </div>
        </div>
        <div class="row justify-content-center d-flex align-items-stretch" >
          <div class="col-lg-6 col-md-4 col-sm-6 col-11">
            <card :style="{ 'background-color': waiverConfigurations.card_color}">

              <div class="row mt-2">
                <div class="col">
                  <base-input :error="errs.waiver" :secondary-color="waiverConfigurations.text_color_card"
                              :input-style="{'color': waiverConfigurations.text_color_card}" :placeholder="$t('checkin.teamLeaderName')"
                              v-model="customer_name"></base-input>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-lg-12">
                  <base-button :style="{'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }"
                               simple class="game-button" @click="lookUpCustomer">{{ $t('checkin.search') }}</base-button>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>

<!--      Select booking slots-->
      <div v-show="bookings.length > 0 && !view_waiver">
        <div class="row mt-3 justify-content-center text-center" v-if="waiverConfigurations.display_section_titles">
          <div class="col" :style="{'font-family': waiverConfigurations.font_family}">
            <h3>
              <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
                {{ sections[1].name }}
              </span>
            </h3>
          </div>
        </div>
        <div :style="{'font-family': waiverConfigurations.font_family_card}" class="row justify-content-center">
          <div class="col-lg-6">
            <card :style="{ 'background-color': waiverConfigurations.card_color}">
              <b-table striped hover :items="bookings"
                       :fields="['check', 'game']">
                <template #head(check)="data">
                  <span style="width: 25px"></span>
                </template>
                <template #head(game)="data">
                  <span></span>
                </template>
                <template v-slot:cell(game)="row">
                  <h4 style="padding-bottom: 0; margin-bottom: 0" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">{{row.item.game_name}}</h4>
                  <p :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">
                    <i class="tim-icons icon-calendar-60 mr-2"></i>{{getDayOfWeek( row.item.booking_date)}} {{getFormattedDate(locale.date_format, row.item.booking_date)}}
                    <i class="tim-icons icon-time-alarm mr-2"></i>{{getDisplayTime(row.item)}}
                  </p>
                </template>
                <template v-slot:cell(check)="row">
                  <div style="width: 25px">
                    <base-checkbox :border-color="waiverConfigurations.button_color" :accent-color="waiverConfigurations.button_color"
                                   :check-mark-color="waiverConfigurations.card_color"
                                   v-model="row.item.selected"></base-checkbox>
                  </div>
                </template>
              </b-table>
              <div class="row justify-content-center" v-if="errs.bookings">
                <div class="col-12">
                  <p class="text-danger text-center" :style="{'font-family': waiverConfigurations.font_family_card}">
                    {{ errs.bookings }}
                  </p>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-1 col-2">
                  <base-button
                    :style="{ 'font-family': waiverConfigurations.font_family_card,
                        'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                    @click="clearBookings" link >
                    <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                  </base-button>
                </div>
                <div class="col-lg-11">
                  <base-button :style="{'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }"
                               simple class="game-button" @click="viewWaiver">View waiver</base-button>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>

<!--      Returning customer gate (after booking selection) -->
      <returning-customer-gate
        v-if="view_waiver && shouldShowGate"
        :api-location="apiLocation"
        :code="$route.params.company"
        waiver-type="lookup"
        :theme="waiverConfigurations"
        :date-mask="dateMask"
        :date-placeholder="datePlaceholder"
        :birthday-mode="birthdayMode"
        :date-format="locale.date_format"
        :first-day-of-week="locale.first_day_of_week"
        :default-country="country.code"
        @confirmed="onGateConfirmed"
        @declined="onGateDeclined" />

<!--      Waiver part-->
      <div v-show="view_waiver && !shouldShowGate">
        <div class="row justify-content-center text-center" v-if="waiverConfigurations.display_section_titles">
          <div class="col">
            <h3 :style="{'font-family': waiverConfigurations.font_family}" >
            <span class="text-uppercase" :style="{'color': waiverConfigurations.text_color }">
             {{ sections[2].name }}
            </span>
            </h3>
          </div>
        </div>

        <div :style="{'font-family': waiverConfigurations.font_family_card}" class="row justify-content-center">
          <div class="col-lg-8">
            <card :style="{ 'background-color': waiverConfigurations.card_color}">
              <!--            Waiver-->
              <span v-html="waiverConfigurations.waiver_text"></span>
              <div class="mt-2" v-if="waiverConfigurations.external_link">
                <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.conditions">
                  <base-checkbox :border-color="waiverConfigurations.button_color" :accent-color="waiverConfigurations.button_color"
                                 :check-mark-color="waiverConfigurations.card_color" v-model="conditions">
                  <span :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.agreeToToS')}}
                    <a :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}" target="_blank" :href="waiverConfigurations.external_link">
                      {{$t('checkin.termsAndConditions')}}
                    </a>.</span>
                  </base-checkbox>
                </base-input>

                <p class="text-danger small" v-if="errs.conditions==true">{{$t('checkin.errors.mustAcceptToS')}}</p>
              </div>
              <div v-if="display.includes('Signature')" class="row mt-3 justify-content-between">
                <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                  <h6 :style="{'color': waiverConfigurations.text_color_card}" class="mt-3">{{$t('checkin.signature')}}</h6>
                </div>
                <div class="mr-3 ml-3">
                  <base-button :style="{'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color,'color': waiverConfigurations.button_color}" size="sm" align="left" simple v-on:click="clearSignature()" type="secondary">
                    {{$t('checkin.clearSignature')}}</base-button>
                </div>
              </div>

              <div class="row" v-if="display.includes('Signature') && view_waiver && !shouldShowGate">

                <div class=" col-lg-12">
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.signature">
                    <VueSignaturePad :custom-style="background_sig"
                                     :style="{'border-color': waiverConfigurations.button_color}"
                                     class="sig-pad" height="200px" ref="signaturePad" />
                  </base-input>
                </div>
              </div>
              <div v-if="display.includes('Photo Opt Out')" class="row">
                <div class="col">
                  <base-checkbox :border-color="waiverConfigurations.button_color" :accent-color="waiverConfigurations.button_color"
                                 :check-mark-color="waiverConfigurations.card_color" class="ml-1" v-model="picture_optout">
                  <span :style="{'color': waiverConfigurations.text_color_card}">
                    {{ optInLabel('Photo Opt Out') }}</span>
                  </base-checkbox>
                </div>
              </div>
              <div v-if="display.includes('Email Opt Out')" class="row">
                <div class="col-12 col-lg-12">
                  <base-checkbox :border-color="waiverConfigurations.button_color" :accent-color="waiverConfigurations.button_color"
                                 :check-mark-color="waiverConfigurations.card_color" class="ml-1" v-model="email_optout">
                  <span :style="{'color': waiverConfigurations.text_color_card}">
                    {{ optInLabel('Email Opt Out') }}</span>
                  </base-checkbox>
                </div>
              </div>

              <!--            User info-->
              <template v-if="!easyCheckin">
              <div class="row mt-3 justify-content-center">
                <div class="col-lg-6 col-12" v-if="display.includes('First Name')">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.firstName')}}
                    <span v-if="requiredFields.includes('First Name')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.first_name" :input-style="{'color': waiverConfigurations.text_color_card}" :placeholder="$t('checkin.firstName')"
                              v-model="user.first_name"></base-input>
                </div>
                <div class="col-lg-6 col-12" v-if="display.includes('Last Name')">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.lastName')}}
                    <span v-if="requiredFields.includes('Last Name')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.last_name" :input-style="{'color': waiverConfigurations.text_color_card}" :placeholder="$t('checkin.lastName')"
                              v-model="user.last_name"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12" v-if="display.includes('Birthday')">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.birthday')}}
                    <span v-if="requiredFields.includes('Birthday')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <birthday-input
                    :mode="birthdayMode"
                    :error="errs.birthday"
                    :text-color="waiverConfigurations.text_color_card"
                  :card-color="waiverConfigurations.card_color"
                    :date-mask="dateMask"
                    :date-placeholder="datePlaceholder"
                    :date-format="locale.date_format"
                    :first-day-of-week="locale.first_day_of_week"
                    v-model="user.birthday"
                  ></birthday-input>
                </div>
                <div class="col-lg-6 col-12" v-if="display.includes('Phone')">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.phone')}}
                    <span v-if="requiredFields.includes('Phone')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input
                    :secondary-color="waiverConfigurations.text_color_card"
                    :error="errs.phone || (user.phoneBlurred ? user.phoneValidationMessage : '')"
                    :input-style="{'color': waiverConfigurations.text_color_card}">
                    <phone-number-input :input-style="{'color': waiverConfigurations.text_color_card}" ref="phoneInput"
                                        v-model="user.phone" @phone-update="handlePhoneUpdate"
                                        :default-country="country.code || 'US'"
                                        @blur="user.phoneBlurred = true"
                    />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6" v-if="display.includes('Email')">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.email')}}
                    <span v-if="requiredFields.includes('Email')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.email || (emailBlurred ? emailTypoWarning(user.email) : '')" :input-style="{'color': waiverConfigurations.text_color_card}" v-model="user.email" :placeholder="$t('checkin.email')" @blur="emailBlurred = true"></base-input>
                </div>
              </div>
              </template>

              <!--            Childen-->
              <div class="row mb-2" v-if="!add_minors && (display.includes('Child First Name') || display.includes('Child Last Name') || display.includes('Child Birthday'))">
                <div class="col">
                  <base-button :style="{ 'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }" simple @click="add_minors = true">{{$t('checkin.addChildren')}}</base-button>
                </div>
              </div>
              <div v-if="add_minors" class="row justify-content-between" v-for="(m, i) in minors" :key="'A' + i">
                <div class="col-lg-2 mt-4">
                  <p class="text-lg-right" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">
                    {{$t('checkin.child')}} {{i+1}}</p>
                </div>
                <div class="col-10 col-lg-3" v-if="display.includes('Child First Name')" style="padding-right: 0px;">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.firstName')}}
                    <span v-if="requiredFields.includes('Child First Name')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.child[i].first_name" :input-style="{'color': waiverConfigurations.text_color_card}"  :placeholder="$t('checkin.firstName')"
                              v-model="m.first_name"></base-input>
                </div>
                <div class="col-10 col-lg-3" v-if="display.includes('Child Last Name')" style="padding-right: 0px;">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.lastName')}}
                    <span v-if="requiredFields.includes('Child Last Name')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>

                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.child[i].last_name" :input-style="{'color': waiverConfigurations.text_color_card}" :placeholder="$t('checkin.lastName')"
                              v-model="m.last_name"></base-input>
                </div>
                <div class="col-10 col-lg-3" v-if="display.includes('Child Birthday')" style="padding-right: 0px;">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.birthday')}}
                    <span v-if="requiredFields.includes('Child Birthday')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <birthday-input
                    :mode="birthdayMode"
                    :error="errs.child[i].birthday"
                    :text-color="waiverConfigurations.text_color_card"
                  :card-color="waiverConfigurations.card_color"
                    :date-mask="dateMask"
                    :date-placeholder="datePlaceholder"
                    :date-format="locale.date_format"
                    :first-day-of-week="locale.first_day_of_week"
                    v-model="m.birthday"
                  ></birthday-input>
                </div>
                <div class="col-1 mr-4 mr-lg-0" >
                  <i :style="{ 'color': waiverConfigurations.button_color }" v-on:click="removeChild(i)"
                     style="cursor: pointer; margin-top: 37px; padding-left: 0px"
                     class="tim-icons icon-simple-remove"></i>
                </div>
              </div>
              <div class="row mb-2" v-if="add_minors">
                <div class="col">
                  <base-button :style="{ 'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }" simple v-on:click="addMinor()">{{$t('checkin.addAnotherChild')}}</base-button>
                </div>
              </div>
              <div class="row mb-2" v-if="add_minors && minors.length > 0 && waiverConfigurations.show_participation_field">
                <div class="col">
                  <base-checkbox :border-color="waiverConfigurations.button_color" :accent-color="waiverConfigurations.button_color"
                                 :check-mark-color="waiverConfigurations.card_color"
                                 v-model="not_participating">
                  <span :style="{'color': waiverConfigurations.text_color_card}">{{ waiverConfigurations.participation_field_text }}
                  </span>
                  </base-checkbox>
                </div>
              </div>

              <!--            Marketing-->
              <div v-if="display.includes('Source')" class="row">
                <div class="col-lg-6">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.howDidYouHearAboutUs')}}
                    <span v-if="requiredFields.includes('Source')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" placeholder="Select">
                    <base-dropdown :style="{'font-family': waiverConfigurations.font_family_card }"
                                   title-classes="form-group form-control" :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                   :font-family="waiverConfigurations.font_family_card"
                                   :title="selectedSource.label"
                    >
                      <a v-for="(s, i) in sources"  :style="{'font-family': waiverConfigurations.font_family_card }"
                         style="white-space: normal; overflow-wrap: break-word;"
                         class="dropdown-item" href="#" :key="'DOJ' + i" @click.prevent="selectedSource = s">
                        {{ s.label }}</a>
                    </base-dropdown>
                  </base-input>

                </div>
                <div v-if="selectedSource === 'Other'" class="col-lg-6">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.pleaseSpecify')}}
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" v-model="otherSource" :input-style="{'color': waiverConfigurations.text_color_card}" :placeholder="$t('checkin.source')"
                  ></base-input>
                </div>
              </div>
              <div v-if="display.includes('Experience')" class="row">
                <div class="col-lg-6">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.experience')}}
                    <span v-if="requiredFields.includes('Experience')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :placeholder="$t('checkin.select')">
                    <base-dropdown :style="{'font-family': waiverConfigurations.font_family_card }"
                                   title-classes="form-group form-control" :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                   :font-family="waiverConfigurations.font_family_card"
                                   :title="selectedExperience.label"
                    >
                      <a v-for="(e, i) in experiences"  :style="{'font-family': waiverConfigurations.font_family_card }"
                         style="white-space: normal; overflow-wrap: break-word;"
                         class="dropdown-item" href="#" :key="'EXX' + i" @click.prevent="selectedExperience = e">
                        {{ e.label }}</a>
                    </base-dropdown>
                  </base-input>
                </div>
              </div>
              <div v-if="display.includes('Location')" class="row">
                <div class="col-lg-4">
                  <label :style="{'color': waiverConfigurations.text_color_card}">{{$t('checkin.whereAreYouFrom')}}
                    <span v-if="requiredFields.includes('Location')" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.location.city" style="margin-bottom: 0px;" placeholder="City" v-model="city" :input-style="{'color': waiverConfigurations.text_color_card}">
                  </base-input>
                </div>
                <div class="col-lg-4">
                  <label :style="{'color': waiverConfigurations.text_color_card}"> &nbsp;
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.location.state"  style="margin-bottom: 0px;" :placeholder="state_placeholder" v-model="selectedState" :input-style="{'color': waiverConfigurations.text_color_card}">
                  </base-input>
                </div>
                <div class="col-lg-4">
                  <label :style="{'color': waiverConfigurations.text_color_card}"> &nbsp;
                  </label>
                  <base-input :secondary-color="waiverConfigurations.text_color_card" :error="errs.location.zip" maxlength="10" style="margin-bottom: 0px;" :placeholder="zip_placeholder" v-model="zip" :input-style="{'color': waiverConfigurations.text_color_card}">
                  </base-input>
                </div>
              </div>
              <!--            Custom fields (from library, attached per section) -->
              <div v-for="link in customFieldsAll" :key="'CF_' + link.link_id" class="row mt-3">
                <div class="col">
                  <!-- Type 2: text input -->
                  <template v-if="link.type === 2">
                    <label :style="{'color': waiverConfigurations.text_color_card}">
                      {{ link.label }}
                      <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                    </label>
                    <base-input :error="errs.customFields[link.custom_field_id]"
                                :secondary-color="waiverConfigurations.text_color_card"
                                v-model="customFieldResponses[link.custom_field_id]"
                                :input-style="{'color': waiverConfigurations.text_color_card}"
                                :placeholder="link.label" />
                  </template>
                  <!-- Type 5: long text -->
                  <template v-else-if="link.type === 5">
                    <label :style="{'color': waiverConfigurations.text_color_card}">
                      {{ link.label }}
                      <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                    </label>
                    <base-input :error="errs.customFields[link.custom_field_id]"
                                :secondary-color="waiverConfigurations.text_color_card"
                                :input-style="{'color': waiverConfigurations.text_color_card}">
                      <textarea class="form-control" rows="4"
                                :style="{'color': waiverConfigurations.text_color_card}"
                                v-model="customFieldResponses[link.custom_field_id]"
                                :placeholder="link.label"></textarea>
                    </base-input>
                  </template>
                  <!-- Type 3: dropdown with optional follow-up field -->
                  <template v-else-if="link.type === 3">
                    <div class="row">
                      <div class="col-lg-6">
                        <label :style="{'color': waiverConfigurations.text_color_card}">
                          {{ link.label }}
                          <span v-if="link.required" :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">*</span>
                        </label>
                        <base-input :error="errs.customFields[link.custom_field_id]"
                                    :secondary-color="waiverConfigurations.text_color_card"
                                    :placeholder="$t('checkin.select')">
                          <base-dropdown :key="'CFD_' + link.link_id + '_' + j"
                                         :style="{'font-family': waiverConfigurations.font_family_card }"
                                         title-classes="form-group form-control"
                                         :text-color="waiverConfigurations.button_color" :border-color="'var(--input-border-color, #7d7d7d99)'"
                                         :font-family="waiverConfigurations.font_family_card"
                                         :title="getDropDownLabel(customFieldResponses[link.custom_field_id]) || $t('checkin.select')">
                            <a v-for="opt in link.dropdown_options" :key="'CFOPT_' + link.link_id + '_' + opt.id"
                               :style="{'font-family': waiverConfigurations.font_family_card }"
                               style="white-space: normal; overflow-wrap: break-word;"
                               class="dropdown-item" href="#"
                               @click.prevent="selectDropdown(link, opt)">
                              {{ getDropDownLabel(opt) }}
                            </a>
                          </base-dropdown>
                        </base-input>
                      </div>
                      <div class="col" v-if="customFieldResponses[link.custom_field_id] && customFieldResponses[link.custom_field_id].has_follow_up_field">
                        <label :style="{'color': waiverConfigurations.text_color_card}">
                          {{ customFieldResponses[link.custom_field_id].follow_up_field_label }}
                          <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                        </label>
                        <base-input :secondary-color="waiverConfigurations.text_color_card"
                                    :input-style="{'color': waiverConfigurations.text_color_card}"
                                    v-model="customFieldResponses[link.custom_field_id].follow_up_response" />
                      </div>
                    </div>
                  </template>
                  <!-- Type 1: checkbox with external links + policies -->
                  <template v-else-if="link.type === 1">
                    <base-checkbox v-on:input="handleCustomFieldInput(link)"
                                   :key="'CFCB_' + link.link_id + '_' + j"
                                   :border-color="waiverConfigurations.button_color"
                                   :accent-color="waiverConfigurations.button_color"
                                   :check-mark-color="waiverConfigurations.card_color"
                                   v-model="customFieldResponses[link.custom_field_id]"
                                   simple size="sm">
                      <span :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color_card}">{{ link.label }}</span>
                      <span v-for="(el, idx) in link.external_links" :key="'CFEL_' + link.link_id + '_' + idx">
                        <a v-on:click="recordInteraction(el)"
                           :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"
                           target="_blank"
                           :href="el.link"> {{ el.link_text }}</a>
                      </span>
                      <span v-for="(p, idx) in link.policies" :key="'CFPL_' + link.link_id + '_' + idx">
                        <a href="#"
                           v-on:click.prevent="openPolicy(p, link)"
                           :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.link_color}"> {{ p.policy_link_text }}</a>
                      </span>
                      <span v-if="link.required" :style="{'color': waiverConfigurations.text_color_card}">*</span>
                    </base-checkbox>
                    <p v-if="errs.customFields[link.custom_field_id]" class="ml-4 small mb-0" style="color: #ec250d">{{ errs.customFields[link.custom_field_id] }}</p>
                  </template>
                </div>
              </div>

              <!--            Submit -->
              <div class="row mt-3 justify-content-center">
                <div class="col-lg-1 col-2">
                  <base-button
                    :style="{ 'font-family': waiverConfigurations.font_family_card,
                        'border-color': waiverConfigurations.button_color,
                        'color': waiverConfigurations.button_color,
                        'width': '100%',
                        'font-size': 'large', 'font-weight': 'bold'}"
                    @click="view_waiver = false" link >
                    <i :style="{'font-size': 'x-large', 'font-weight': 'bold'}" class="tim-icons el-icon-back"></i>
                  </base-button>
                </div>
                <div class="col text-center">
                  <base-button simple  v-on:click="confirmCheckin()" :disabled="disabled"
                               class="game-button"
                               :style="{'font-family': waiverConfigurations.font_family_card, 'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }">
                    <span class="ml-1 mt-1">{{$t('checkin.submitWaiver')}}</span>
                  </base-button>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>




    </div>

    <!-- Custom field policy modal (opened by policy buttons inside checkbox custom fields) -->
    <modal :show.sync="modals.policy" id="cfPolicyModal"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card v-if="selectedPolicy"
            :style="{ 'background-color': waiverConfigurations.background_color}"
            header-classes="bg-white pb-5"
            class="border-0 mb-0">
        <p :style="{'color': waiverConfigurations.text_color}" v-html="selectedPolicy.policy"></p>
        <div class="row mt-3 justify-content-center">
          <div class="col text-center">
            <base-button :style="{ 'width': '100%', 'font-family': waiverConfigurations.font_family_card,
                          'border-color': waiverConfigurations.text_color, 'color': waiverConfigurations.text_color }"
                         simple
                         v-on:click="agreeToPolicy()">{{ $t('book.iAgree') || 'I agree' }}</base-button>
          </div>
        </div>
      </card>
    </modal>

    <!-- Dropdown option popup (opened when a selected option has has_popup + description) -->
    <modal :show.sync="modals.dropdown_popup"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-lg">
      <card v-if="popupOption"
            :style="{ 'background-color': waiverConfigurations.background_color}"
            header-classes="bg-white pb-5"
            class="border-0 mb-0">
        <h4 :style="{'font-family': waiverConfigurations.font_family_card, 'color': waiverConfigurations.text_color}">{{ popupOption.name }}</h4>
        <div :style="{'color': waiverConfigurations.text_color, 'font-family': waiverConfigurations.font_family_card}" v-html="popupOption.description"></div>
        <div class="row mt-3 justify-content-center">
          <div class="col text-center">
            <base-button :style="{ 'width': '100%', 'font-family': waiverConfigurations.font_family_card,
                          'border-color': waiverConfigurations.button_color, 'color': waiverConfigurations.button_color }"
                         simple
                         v-on:click="acknowledgeDropdownPopup()">OK</base-button>
          </div>
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import {API_LOCATION} from "@/api-config";
import _ from 'lodash';
import axios from "axios";
import countries from "@/assets/countries.json";
import NotFoundPage from "../../pages/GeneralViews/NotFoundPage";
import {DatePicker} from "element-ui";
import moment from "moment";
import {dayOfWeek, formattedDate, displayTime} from "@/plugins/dateFormatter";
import {BTable} from "bootstrap-vue";
import swal from "sweetalert2";
import PhoneNumberInput from '@/components/PhoneNumberInput.vue';
import ReturningCustomerGate from '@/components/ReturningCustomerGate.vue';
import BirthdayInput from '@/components/BirthdayInput.vue';
import { isValidEmail } from '@/util/emailValidator';
import emailTypoWarning from '@/mixins/emailTypoWarning';
import { syncServerNow, getNow } from '@/util/serverTime';
import { inputBorderColor } from '@/util/bookingTheme';
import { isValidIsoDate, ageFromIsoDate } from '@/util/birthdayDate';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { applyPageLocale } from '@/i18n';

export default {
  name: "SearchableWaiver",
  mixins: [emailTypoWarning],
  components: {
    NotFoundPage,
    [DatePicker.name]: DatePicker,
    BTable,
    PhoneNumberInput,
    ReturningCustomerGate,
    BirthdayInput,
    LanguageSwitcher
  },
  data() {
    return {
      loadComplete: false,
      view_waiver: false,
      customer_name: '',
      is_kiosk: false,
      not_participating: false,
      add_minors: false,
      bookings: [],
      state_placeholder: 'State',
      country: '',
      countries: countries.countries,
      background_sig: { 'background-color': 'white'},
      loading: false,
      locale: '',
      day_of_week: '',
      picture_optout: false,
      email_optout: false,
      notFound: false,
      waiverConfigurations: '',
      conditions: false,
      current: '',
      fields: [],
      sections: [],
      display: [],
      signature: '',
      selectedExperience: '',
      selectedSource: '',
      otherSource: '',
      selectedState: '',
      city: '',
      zip: '',
      disabled: false,
      experiences: [
        {
          value: this.$t('checkin.exp.beginner'),
          label: this.$t('checkin.exp.beginnerDesc'),
        },
        {
          value: this.$t('checkin.exp.intermediate'),
          label: this.$t('checkin.exp.intermediateDesc'),
        },
        {
          value: this.$t('checkin.exp.expert'),
          label: this.$t('checkin.exp.expertDesc'),
        },
        {
          value: this.$t('checkin.exp.master'),
          label: this.$t('checkin.exp.masterDesc'),
        },
        {
          value: this.$t('checkin.exp.grandmaster'),
          label: this.$t('checkin.exp.grandmasterDesc'),
        }
      ],
      sources: [
        {
          value: 'Google',
          label: 'Google',
        },
        {
          value: 'Instagram',
          label: 'Instagram',
        },
        {
          value: 'Facebook',
          label: 'Facebook',
        },
        {
          value: 'Yelp',
          label: 'Yelp',
        },
        {
          value: this.$t('checkin.sources.wordOfMouth'),
          label: this.$t('checkin.sources.wordOfMouth'),
        },
        {
          value: this.$t('checkin.sources.other'),
          label: this.$t('checkin.sources.other'),
        },
      ],
      emailBlurred: false,
      user: {
        email: '',
        phone: '',
        first_name: '',
        last_name: '',
        birthday: '',
        phoneE164: '',
        phoneValidationStatus: 'valid',
        phoneValidationMessage: '',
        phoneBlurred: false
      },
      minors: [{
        first_name: '',
        last_name: '',
        birthday: ''
      }],
      errs: {
        waiver: '',
        bookings: '',
        email: '',
        first_name: '',
        last_name: '',
        birthday: '',
        phone: '',
        signature: '',
        conditions: '',
        source: '',
        location: {
          city: '',
          state: '',
          zip: ''
        },
        child: [
          {
            first_name: '',
            last_name: '',
            birthday: ''
          }
        ],
        experience: '',
        customFields: {},
      },
      requiredFields: [],
      datePlaceholder: 'MM/DD/YYYY',
      dateMask: '##/##/####',
      customFieldLinks: [],
      customFieldResponses: {},
      selectedCf: null,
      selectedPolicy: null,
      popupOption: null,
      modals: {
        policy: false,
        dropdown_popup: false,
      },
      j: 0,
      gateResolved: false,
      easyCheckin: false,
      apiLocation: API_LOCATION,
    }
  },
  computed: {
    shouldShowGate() {
      return !this.gateResolved && this.waiverConfigurations && Number(this.waiverConfigurations.allow_easy_checkin) === 1
    },
    birthdayMode() {
      return this.waiverConfigurations.birthday_input_style || 'typed'
    },
    pickerOptions() {
      return {
        disabledDate: (time) => this.disabledDates(time, this.current),
        // group setting is 0-6 (Sunday=0, FullCalendar convention); Element UI wants 1-7 (Sunday=7)
        firstDayOfWeek: this.locale.first_day_of_week === 0 ? 7 : this.locale.first_day_of_week
      };
    },
    customFieldsAll(){
      return [...this.customFieldLinks]
        .filter(link => this.isFieldVisible(link))
        .sort((a, b) => {
          const sa = Number(a.waiver_section || 0)
          const sb = Number(b.waiver_section || 0)
          if(sa !== sb) return sa - sb
          return (a.position || 0) - (b.position || 0)
        })
    },
    // Localized term for the postal code field, driven by the venue's country
    // (e.g. "Zip" in the US, "Postal code" in Canada, "Postcode" in the UK).
    zip_placeholder(){
      return (this.country && this.country.zip_label) || 'Zip'
    },
  },
  watch: {
    view_waiver(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.signaturePad && this.$refs.signaturePad.resizeCanvas) {
            this.$refs.signaturePad.resizeCanvas(); // if supported
          } else if (this.$refs.signaturePad && this.$refs.signaturePad.clearSignature) {
            this.$refs.signaturePad.clearSignature(); // a safe redraw
          }
        });
      }
    }
  },
  methods: {
    onGateConfirmed({ email, partialUser }) {
      this.user.email = email
      if (partialUser.first_name) this.user.first_name = partialUser.first_name
      if (partialUser.last_name) this.user.last_name = partialUser.last_name
      if (partialUser.phone) {
        this.user.phone = partialUser.phone
        this.user.phoneE164 = partialUser.phone
      }
      if (partialUser.birthday) {
        this.user.birthday = partialUser.birthday
        this.user.formatted_birthday = this.validateBirthdayValue(partialUser.birthday).validDate
      }
      // Pre-fill the team-leader name search box if the customer chose to update name.
      // (When they didn't update, we have no name client-side — the lookup-by-name step still works.)
      if (partialUser.first_name || partialUser.last_name) {
        const parts = [partialUser.first_name, partialUser.last_name].filter(Boolean).join(' ')
        if (parts) this.customer_name = parts
      }
      this.easyCheckin = true
      this.gateResolved = true
    },
    onGateDeclined() {
      this.easyCheckin = false
      this.gateResolved = true
    },
    getOptInField(name){
      if(!Array.isArray(this.fields)) return null
      return this.fields.find(f => f.name === name) || null
    },
    isOptInMode(name){
      const field = this.getOptInField(name)
      return field ? !!field.is_optin : false
    },
    optInLabel(name){
      const field = this.getOptInField(name)
      if(field && field.label) return field.label
      const isOptin = field ? !!field.is_optin : false
      if(name === 'Email Opt Out'){
        return isOptin ? this.$t('checkin.consentToMailingLists') : this.$t('checkin.doNotIncludeInMailingLists')
      }
      if(name === 'Photo Opt Out'){
        return isOptin ? this.$t('checkin.consentToSharePhotos') : this.$t('checkin.doNotSharePhotos')
      }
      return ''
    },
    isFieldVisible(link){
      const allowed_games = link.visibility_conditions ? (typeof link.visibility_conditions === 'string' ? JSON.parse(link.visibility_conditions) : link.visibility_conditions) : []
      let event_scope
      if (allowed_games.length > 0) event_scope = 'specific'
      else if (link.visibility) event_scope = 'none'
      else event_scope = 'all'
      // Match against the bookings the customer actually selected for this waiver.
      // Iterating all looked-up bookings would surface fields scoped to games the user didn't pick.
      // Waivers have no cart context, so the gift card axis cannot match.
      const selected = this.bookings.filter(b => b && b.selected && b.game_id)
      for (const b of selected) {
        if (event_scope === 'all') return true
        if (event_scope === 'specific' && _.find(allowed_games, {id: b.game_id})) return true
      }
      return false
    },
    validateCustomFieldsAll(){
      let errors = 0
      for(const link of this.customFieldLinks){
        if(!this.isFieldVisible(link)) continue
        if(!link.required) continue
        const val = this.customFieldResponses[link.custom_field_id]
        let isMissing = false
        if(link.type === 1){
          isMissing = !val
        } else if(link.type === 3){
          if(!val || !val.name){
            isMissing = true
          } else if(val.has_follow_up_field && (val.follow_up_response == null || String(val.follow_up_response).trim() === '')){
            isMissing = true
          }
        } else {
          isMissing = (val == null || String(val).trim() === '')
        }
        if(isMissing){
          this.$set(this.errs.customFields, link.custom_field_id, 'Required')
          errors++
        } else {
          this.$set(this.errs.customFields, link.custom_field_id, '')
        }
      }
      return errors
    },
    handleCustomFieldInput(link){
      let ready = false
      if(link.interaction_required){
        let totalCount = 0
        let interactiveCount = 0
        const links = link.external_links || []
        for(const el of links){
          totalCount++
          if(el.user_interaction){ interactiveCount++ }
        }
        const policies = link.policies || []
        for(const p of policies){
          totalCount++
          if(p.user_interaction){ interactiveCount++ }
        }
        if(totalCount === interactiveCount){
          ready = true
          this.$set(this.errs.customFields, link.custom_field_id, '')
        } else {
          ready = false
          this.$set(this.customFieldResponses, link.custom_field_id, false)
          this.$set(this.errs.customFields, link.custom_field_id, 'Please read all attached policies')
        }
        this.j++
      } else {
        ready = true
      }
      return ready
    },
    recordInteraction(item){
      this.$set(item, 'user_interaction', 1)
    },
    openPolicy(item, link){
      this.selectedCf = link
      this.selectedPolicy = item
      this.modals.policy = true
      this.$nextTick(() => {
        const root = document.getElementById('cfPolicyModal')
        if(root) root.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      })
    },
    agreeToPolicy(){
      this.recordInteraction(this.selectedPolicy)
      if(this.handleCustomFieldInput(this.selectedCf)){
        this.$set(this.customFieldResponses, this.selectedCf.custom_field_id, true)
        this.j++
      }
      this.modals.policy = false
      this.selectedCf = null
      this.selectedPolicy = null
    },
    acknowledgeDropdownPopup(){
      if(this.popupOption){
        this.recordInteraction(this.popupOption)
      }
      this.modals.dropdown_popup = false
      this.popupOption = null
    },
    selectDropdown(link, option){
      const response = {
        name: option.name,
        has_follow_up_field: !!option.has_follow_up_field,
        follow_up_field_label: option.follow_up_field_label || '',
        follow_up_response: ''
      }
      this.$set(this.customFieldResponses, link.custom_field_id, response)
      this.j++
      if(option.has_popup && option.description){
        this.popupOption = option
        this.modals.dropdown_popup = true
      }
    },
    getDropDownLabel(item){
      if(item){
        return item.name
      }
      return ''
    },
    buildCustomFieldResponsesPayload(){
      return this.customFieldLinks
        .filter(link => this.isFieldVisible(link))
        .map(link => {
          const raw = this.customFieldResponses[link.custom_field_id]
          let response = ''
          if(link.type === 1){
            response = raw ? '1' : '0'
          } else if(link.type === 3 && raw && typeof raw === 'object'){
            const fu = (raw.follow_up_response || '').trim()
            if(raw.has_follow_up_field && fu){
              response = (raw.name || '') + ': ' + fu
            } else {
              response = raw.name || ''
            }
          } else if(raw != null){
            response = String(raw)
          }
          return { custom_field_id: link.custom_field_id, response }
        })
    },
    handlePhoneUpdate(phoneData) {
      this.user.phoneE164 = phoneData.e164;
      this.user.phoneValidationStatus = phoneData.validationStatus || 'valid';
      this.user.phoneValidationMessage = phoneData.validationMessage || '';
    },
    addMinor(){
      this.minors.push(
        {
          first_name: '',
          last_name: '',
          birthday: ''
        }
      )
      this.errs.child.push({
        first_name: '',
        last_name: '',
        birthday: ''
      })
    },
    removeChild(i){
      this.minors.splice(i, 1)
      this.errs.child.splice(i, 1)
    },
    getSignature () {
      if(this.$refs.signaturePad == undefined){
        return
      }
      var png =  this.$refs.signaturePad.saveSignature().data
      if (this.$refs.signaturePad.isEmpty()) {
        return ''
      } else {
        return png
      }
    },
    clearSignature(){
      this.$refs.signaturePad.clearSignature()
    },
    setSignatureData(){
      this.signature = this.getSignature()
      let errors = 0

      if(this.signature == ''){
        errors++
        this.errs.signature = this.$t('checkin.errors.signature')
      } else {
        this.errs.signature = ""
      }
      if(this.waiverConfigurations.external_link != null && this.conditions == false){
        errors++
        this.errs.conditions = this.$t('checkin.errors.mustAcceptToS')
      } else {
        this.errs.conditions = ""
      }
      if(errors > 0){
        return
      }
    },
    isReasonableAge(birthday) {
      const months = this.$t('dates.months');
      const shortMonths = this.$t('dates.shortMonths');
      let year, month, day;

      // Parse birthday based on date_format
      switch (this.locale.date_format) {
        case 'dd/MM/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          day = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          year = parseInt(parts[2], 10);
          break;
        }
        case 'MM/dd/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          month = parseInt(parts[0], 10) - 1; // 0-based months
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          break;
        }
        case 'yyyy/MM/dd': {
          const regEx = /^\d{4}\/\d{2}\/\d{2}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          year = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          day = parseInt(parts[2], 10);
          break;
        }
        case 'dd MMM yyyy': {
          const regEx = /^\d{2}\s\w+\s\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split(' ');
          day = parseInt(parts[0], 10);
          const monthName = parts[1];
          month = shortMonths.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          year = parseInt(parts[2], 10);
          if (month === -1) return false; // Invalid month name
          break;
        }
        case 'MMMM dd, yyyy': {
          const regEx = /^[A-Za-z]+\s\d{1,2},?\s\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split(/[\s,]+/);
          const monthName = parts[0];
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          month = months.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          if (month === -1) return false; // Invalid month name
          break;
        }
        default:
          return false; // Unknown format
      }

      // Validate date
      const birthDate = new Date(year, month, day);
      if (
        birthDate.getFullYear() !== year ||
        birthDate.getMonth() !== month ||
        birthDate.getDate() !== day ||
        isNaN(birthDate.getTime())
      ) {
        return false;
      }

      // Calculate age
      const today = new Date(); // June 10, 2025
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      // Check if age is reasonable
      return age >= 0 && age <= 120;
    },
    isUnderEighteen(birthday) {
      const months = this.$t('dates.months');
      const shortMonths = this.$t('dates.shortMonths');
      let year, month, day;

      // Parse birthday based on date_format
      switch (this.locale.date_format) {
        case 'dd/MM/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          day = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          year = parseInt(parts[2], 10);
          break;
        }
        case 'MM/dd/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          month = parseInt(parts[0], 10) - 1; // 0-based months
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          break;
        }
        case 'yyyy/MM/dd': {
          const regEx = /^\d{4}\/\d{2}\/\d{2}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split('/');
          year = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          day = parseInt(parts[2], 10);
          break;
        }
        case 'dd MMM yyyy': {
          const regEx = /^\d{2}\s\w+\s\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split(' ');
          day = parseInt(parts[0], 10);
          const monthName = parts[1];
          month = shortMonths.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          year = parseInt(parts[2], 10);
          if (month === -1) return false; // Invalid month name
          break;
        }
        case 'MMMM dd, yyyy': {
          const regEx = /^[A-Za-z]+\s\d{1,2},?\s\d{4}$/;
          if (!birthday.match(regEx)) return false;
          const parts = birthday.split(/[\s,]+/);
          const monthName = parts[0];
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          month = months.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          if (month === -1) return false; // Invalid month name
          break;
        }
        default:
          return false; // Unknown format
      }

      // Validate date
      const birthDate = new Date(year, month, day);
      if (
        birthDate.getFullYear() !== year ||
        birthDate.getMonth() !== month ||
        birthDate.getDate() !== day ||
        isNaN(birthDate.getTime())
      ) {
        return false;
      }

      // Calculate age
      const today = new Date(); // June 10, 2025
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      // Check if under 18
      return age < 18;
    },
    validateBirthdayValue(raw) {
      if (this.birthdayMode === 'typed') {
        return {
          validDate: this.isValidDate(raw),
          reasonableAge: this.isReasonableAge(raw),
          underEighteen: this.isUnderEighteen(raw)
        }
      }
      const valid = isValidIsoDate(raw)
      const age = ageFromIsoDate(raw)
      return {
        validDate: valid ? raw : false,
        reasonableAge: valid && age >= 0 && age <= 120,
        underEighteen: valid && age < 18
      }
    },
    isValidDate(dateString) {
      const months = this.$t('dates.months');
      const shortMonths = this.$t('dates.shortMonths');
      let year, month, day;

      switch (this.locale.date_format) {
        case 'dd/MM/yyyy': {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split('/');
          day = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          year = parseInt(parts[2], 10);
          break;
        }
        case 'MM/dd/yyyy' : {
          const regEx = /^\d{2}\/\d{2}\/\d{4}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split('/');
          month = parseInt(parts[0], 10) - 1; // 0-based months
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          break;
        }
        case 'yyyy/MM/dd': {
          const regEx = /^\d{4}\/\d{2}\/\d{2}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split('/');
          year = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1; // 0-based months
          day = parseInt(parts[2], 10);
          break;
        }
        case 'dd MMM yyyy': {

          const regEx = /^\d{2}\s\w+\s\d{4}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split(' ');
          day = parseInt(parts[0], 10);
          const monthName = parts[1];
          // month = shortMonths.indexOf(monthName); // Find month index
          month = shortMonths.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          year = parseInt(parts[2], 10);
          if (month === -1) return false; // Invalid month name
          break;
        }
        case 'MMMM dd, yyyy': {
          const regEx = /^[A-Za-z]+\s\d{1,2},?\s\d{4}$/;
          if (!dateString.match(regEx)) return false;
          const parts = dateString.split(/[\s,]+/);
          const monthName = parts[0];
          day = parseInt(parts[1], 10);
          year = parseInt(parts[2], 10);
          month = months.findIndex(m => m.toLowerCase() === monthName.toLowerCase());
          if (month === -1) return false; // Invalid month name
          break;
        }
        default:
          return false; // Unknown format
      }

      // Validate date
      const dateObj = new Date(year, month, day);
      if (
        dateObj.getFullYear() !== year ||
        dateObj.getMonth() !== month ||
        dateObj.getDate() !== day ||
        isNaN(dateObj.getTime())
      ) {
        return false;
      }

      // Return in YYYY-MM-DD format
      const formattedYear = dateObj.getFullYear();
      const formattedMonth = String(dateObj.getMonth() + 1).padStart(2, '0'); // 1-based months
      const formattedDay = String(dateObj.getDate()).padStart(2, '0');
      return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    },
    getSource(){
      if(this.selectedSource === 'Other'){
        return this.otherSource.toLowerCase()
      } else {
        if(this.selectedSource.hasOwnProperty('value')){
          return this.selectedSource.value.toLowerCase()
        }
        return ''
      }
    },
    validateFields(){
      //validation
      let errors = 0
      // Easy check-in: server merges name/phone/birthday from prior waiver — skip user-info gates only.
      // Children, marketing, custom fields and any other required-field gate still apply.
      if (!this.easyCheckin) {
        //Email
        if(this.isEmailValid(this.user.email) == false){
          errors++
          this.errs.email = this.$t('checkin.errors.email')
        } else {
          this.errs.email = ""
        }
        //User data
        if((this.user.first_name === '' || this.sanitizeNameInput(this.user.first_name) === '')
          && this.requiredFields.includes('First Name')){
          errors++
          this.errs.first_name = this.$t('checkin.errors.firstName')
        } else {
          this.errs.first_name = ""
        }
        if((this.user.last_name === '' || this.sanitizeNameInput(this.user.last_name) === '')
          && this.requiredFields.includes('Last Name')){
          errors++
          this.errs.last_name = this.$t('checkin.errors.lastName')
        } else {
          this.errs.last_name = ""
        }

        let { validDate, reasonableAge, underEighteen } = this.validateBirthdayValue(this.user.birthday)

        if((!validDate || !reasonableAge || underEighteen) && this.requiredFields.includes('Birthday')){
          errors++
          this.errs.birthday = this.$t('checkin.errors.birthday')
        } else if(this.user.birthday !== '' && (!validDate || !reasonableAge || underEighteen)) {
          errors++
          this.errs.birthday = this.$t('checkin.errors.birthday')
        }else {
          this.errs.birthday = ""
        }

        this.user.formatted_birthday = validDate

        if(this.user.phone == '' && this.requiredFields.includes('Phone')){
          errors++
          this.errs.phone = this.$t('checkin.errors.phone')
        } else if(this.user.phoneValidationStatus === 'invalid' && this.requiredFields.includes('Phone')) {
          errors++
          this.errs.phone = this.$t('book.errors.phoneInvalid')
        } else {
          this.errs.phone = ""
        }
      }

      //Children
      if(this.add_minors){
        for(let n in this.minors){

          if((this.minors[n].first_name === '' || !this.minors[n].first_name || this.sanitizeNameInput(this.minors[n].first_name) === '')
            && this.requiredFields.includes('Child First Name')){
            errors++
            this.errs.child[n].first_name = this.$t('checkin.errors.firstName')
          } else {
            this.errs.child[n].first_name = ""
          }

          if((this.minors[n].last_name === '' || !this.minors[n].last_name || this.sanitizeNameInput(this.minors[n].last_name) === '')
            && this.requiredFields.includes('Child Last Name')){
            errors++
            this.errs.child[n].last_name = this.$t('checkin.errors.lastName')
          } else {
            this.errs.child[n].last_name = ""
          }

          let { validDate: validDateMinor, reasonableAge: reasonableAgeMinor } = this.validateBirthdayValue(this.minors[n].birthday)

          if(this.requiredFields.includes('Child Birthday') && (!this.minors[n].birthday || this.minors[n].birthday == '')){
            errors++
            this.errs.child[n].birthday = this.$t('checkin.errors.birthdayEmpty')
          } else if((this.minors[n].birthday != '') && (!validDateMinor || !reasonableAgeMinor)) {
            errors++
            this.errs.child[n].birthday = this.$t('checkin.errors.birthday')
          } else {
            this.errs.child[n].birthday = ""
          }
          this.minors[n].formatted_birthday = validDateMinor
        }
      }

      //Marketing
      if(this.selectedSource == '' && this.requiredFields.includes('Source')){
        errors++
        this.errs.source = this.$t('checkin.errors.required')
      } else {
        this.errs.source = ""
      }
      if(this.selectedExperience == '' && this.requiredFields.includes('Experience')){
        errors++
        this.errs.experience = this.$t('checkin.errors.required')
      } else {
        this.errs.experience = ""
      }
      if(this.selectedState == '' && this.requiredFields.includes('Location')){
        errors++
        this.errs.location.state =  this.$t('checkin.errors.required')
      } else {
        this.errs.location.state = ""
      }
      if(this.city == '' && this.requiredFields.includes('Location')){
        errors++
        this.errs.location.city =  this.$t('checkin.errors.required')
      } else {
        this.errs.location.city = ""
      }
      if(this.zip == '' && this.requiredFields.includes('Location')){
        errors++
        this.errs.location.zip =  this.$t('checkin.errors.required')
      } else {
        this.errs.location.zip = ""
      }

      errors += this.validateCustomFieldsAll()

      if(errors > 0){
        return false
      }
      return true
    },
    viewWaiver(){
      // Check if at least one booking/game is selected
      let hasSelectedBooking = this.bookings.some(booking => booking.selected);
      if(!hasSelectedBooking){
        this.errs.bookings = this.$t('checkin.errors.selectGamesToCheckIn')
        return
      }
      this.errs.bookings = ""
      this.view_waiver = true
    },
    clearBookings(){
      this.bookings = []
    },
    getDayOfWeek(d){
      if(this.locale.show_day_of_week){
        return dayOfWeek(d) + ', '
      }
      return ''
    },
    getFormattedDate(format, d){
      return formattedDate(format, d)
    },
    getDisplayTime(slot){
      return displayTime(slot, this.locale.time_format)
    },
    isEmailValid(emailString) {
      // Use centralized email validator utility with comprehensive TLD whitelist
      return isValidEmail(emailString);
    },
    async lookUpCustomer(){
      // Without a name the server would match every transaction on the date and return
      // the whole day's bookings, letting a guest check in to someone else's slot.
      const name = (this.customer_name || '').trim()
      if(name.length < 2){
        this.errs.waiver = this.$t('checkin.errors.teamLeaderNameRequired')
        this.bookings = []
        return
      }

      this.loading = true
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/transaction?name='
        + encodeURIComponent(name) + '&date=' + moment(this.current, 'YYYY-MM-DD').format('YYYY-MM-DD')

      axios.get(url)
        .then(response => {
          this.bookings = response.data.booking_slots
          this.errs.waiver = ''
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.errs.waiver = 'Waiver could not be found'
          console.log(err)
        })
    },
    // The venue's operating day: before day_rollover_time (venue clock), the
    // previous calendar date is still "today" so late-night groups can reach
    // their waivers. Defaults to the plain calendar date until the config loads.
    effectiveToday(){
      const rollover = (this.locale && this.locale.day_rollover_time) || '00:00:00'
      const now = moment(getNow())
      if (now.format('HH:mm:ss') < rollover) {
        now.subtract(1, 'day')
      }
      return now.format('YYYY-MM-DD')
    },
    disabledDates(time) {
      return moment(time).isBefore(this.effectiveToday(), 'day');
    },
    showPrevious(d) {
      const today = moment().startOf('day');
      return moment(d).isSameOrBefore(today, 'day');
    },
    decrementDay(d){
      let day = moment(d)
      this.current = day.subtract(1, 'days').format('YYYY-MM-DD')
    },
    incrementDay(d){
      let day = moment(d)
      this.current = day.add(1, 'days').format('YYYY-MM-DD')
    },
    getDateMask(date_format){
      switch (date_format) {
        case 'DD/MM/YYYY':
          return '##/##/####';
        case 'MM/DD/YYYY':
          return '##/##/####';
        case 'YYYY/MM/DD':
          return '####/##/##';
        case 'DD MMM YYYY':
          return '## AAA ####';
        case 'MMMM DD, YYYY':
          return '';
        default:
          return '##/##/####'; // Fallback to MM/DD/YYYY
      }
    },
    getDatePlaceholder(date_format){
      const prefix = this.$t('dates.examplePrefix');
      const months = this.$t('dates.months');
      const shortMonths = this.$t('dates.shortMonths');
      const exampleDay = '28';
      const exampleMonthIdx = 5; // June (0-based index)
      const exampleYear = '2000';

      switch (date_format) {
        case 'DD/MM/YYYY':
          return `${prefix}${exampleDay}/06/${exampleYear}`;
        case 'MM/DD/YYYY':
          return `${prefix}06/${exampleDay}/${exampleYear}`;
        case 'YYYY/MM/DD':
          return `${prefix}${exampleYear}/06/${exampleDay}`;
        case 'DD MMM YYYY':
          return `${prefix}${exampleDay} ${shortMonths[exampleMonthIdx]} ${exampleYear}`;
        case 'MMMM DD, YYYY':
          return `${prefix}${months[exampleMonthIdx]} ${exampleDay}, ${exampleYear}`;
        default:
          return `${prefix}06/${exampleDay}/${exampleYear}`; // Fallback to MM/DD/YYYY
      }
    },
    async confirmCheckin(){
      this.setSignatureData()
      if(!this.validateFields()){return}

      // Filter out empty minors without mutating the original array
      let minorsForSubmission = this.minors.filter(minor => minor.first_name || minor.last_name)

      // Create copies with formatted birthdays for the API payload
      // Do NOT mutate this.user.birthday or this.minors[m].birthday
      // so validation still works if the user goes back after an error
      minorsForSubmission = minorsForSubmission.map(minor => ({
        ...minor,
        birthday: minor.formatted_birthday
      }))

      let checkInGamesForSubmission = []
      for(let n in this.bookings){
        if(this.bookings[n].selected){
          checkInGamesForSubmission.push({
            booking: { id: this.bookings[n].id},
            game: {id: this.bookings[n].game_id
          }})
        }
      }

      this.loading = true
      let url = API_LOCATION + 'checkin'

      let data = {
        waiver_configuration_id: this.waiverConfigurations.id,
        company_id: this.waiverConfigurations.company_id,
        user: {
          ...this.user,
          birthday: this.user.formatted_birthday,  // Use formatted version for API
          phone: this.user.phoneE164 || this.user.phone  // Use E.164 if available
        },
        bookings: checkInGamesForSubmission,
        minors: minorsForSubmission,
        signature: this.signature,
        picture_optout: this.isOptInMode('Photo Opt Out') ? !this.picture_optout : this.picture_optout,
        email_optout: this.isOptInMode('Email Opt Out') ? !this.email_optout : this.email_optout,
        experience: this.selectedExperience.hasOwnProperty('value') ? this.selectedExperience.value.toLowerCase()  : '',
        location_city: this.city,
        location_state: this.selectedState,
        location_zip: this.zip,
        source: this.getSource(),
        not_participating: this.not_participating,
        custom_field_responses: this.buildCustomFieldResponsesPayload(),
        locale: this.$i18n.locale,
        easy_checkin: this.easyCheckin
      }

      this.axios.post(url, data)
        .then(response => {
          this.loading = false
          this.disabled = true
          swal({
            title: this.$t('checkin.swals.congratulations'),
            text: this.$t('checkin.swals.allSet'),
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: '#fd5d93',
            confirmButtonText: 'OK'
          }).then((response)=> {
            window.location.reload();
          })
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
          if(err.response.data == 'Waiver record already exists'){
            swal({
              title: this.$t('checkin.swals.error'),
              text: this.$t('checkin.swals.alreadyCheckedIn'),
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: '#fd5d93',
              confirmButtonText: 'OK'
            })
          }
        })
    },
    sanitizeNameInput(name) {
      if (!name || typeof name !== 'string') return '';

      // Normalize spacing
      name = name.trim().replace(/\s+/g, ' ');

      // Disallow email addresses
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(name)) return '';

      // Disallow phone numbers (7+ digits)
      const digitsOnly = name.replace(/[\s\-\(\)+]/g, '');
      if (/^\d{7,}$/.test(digitsOnly)) return '';

      // Require at least one valid letter (Latin or Greek)
      if (!/[a-zA-Z\u0370-\u03FF\u1F00-\u1FFF]/.test(name)) return '';

      // Disallow common bad values
      const bad = ['n/a', 'na', 'test', 'unknown', 'none'];
      if (bad.includes(name.toLowerCase())) return '';

      // Enforce length limits
      if (name.length < 2 || name.length > 100) return '';

      return name;
    },
    async getWaiverConfigurations(){
      this.loading = true
      let code = this.$route.params.company
      let url = API_LOCATION + 'bookings/company-groups/' + code + '/waiver?type=lookup'

      axios.get(url)
        .then(response => {
          this.loadComplete = true
          this.notFound = false
          this.waiverConfigurations = response.data.config[0]
          document.documentElement.style.setProperty('--input-border-color', inputBorderColor(this.waiverConfigurations))
          this.fields = response.data.fields
          this.sections = response.data.sections
          this.locale = response.data.locale
          syncServerNow(response.data.server_now)
          this.current = this.effectiveToday()
          applyPageLocale(this.locale && this.locale.default_locale, this.waiverConfigurations && Number(this.waiverConfigurations.show_language_switcher) === 1)
          this.customFieldLinks = response.data.custom_field_links || []
          // Build the full responses object first then assign once, so Vue 2 makes
          // every key reactive at construction time.
          const initialResponses = {}
          for(const link of this.customFieldLinks){
            initialResponses[link.custom_field_id] = (link.type === 1) ? false : ''
          }
          this.customFieldResponses = initialResponses
          for(let n in this.fields){
            if(this.fields[n].is_active == 1){
              this.display.push(this.fields[n].name)
              if(this.fields[n].is_required){
                this.requiredFields.push(this.fields[n].name)
              }
            }
          }
          this.country = _.find(this.countries, { code: this.locale.country })

          if(this.locale.country !== 'US'){
            this.state_placeholder = this.$t('checkin.country')
          }
          if(this.locale.show_day_of_week){
            this.day_of_week = 'ddd, '
          }

          this.dateMask = this.getDateMask(this.locale.date_format)
          this.datePlaceholder = this.getDatePlaceholder(this.locale.date_format)

          //Fix year for el date picker
          this.locale.date_format = this.locale.date_format.replaceAll('Y', 'y')
          this.locale.date_format = this.locale.date_format.replaceAll('D', 'd')

          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.notFound = true
          console.log(err)
        })
    },
  },
  mounted() {
    if(this.$route.name === 'Checkin-kiosk'){
      this.is_kiosk = true
    }
    this.current = moment().format('YYYY-MM-DD')
    this.getWaiverConfigurations()
  }
}
</script>

<style scoped>
.game-button{
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;

}
.sig-pad {
  border-width: 2px;
  border-style: solid;
  border-radius: 5px;
}
</style>
